module.exports = {"410371001":"瀛洲街道","410371002":"辛店街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410371.json
// module id = 1552
// module chunks = 0